<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div
    class="agpr-datePicker-panel-header"
    [ngClass]="{ 'agpr-datePicker-panel-header--bottomBorder': currentView === calendarViews.MONTH || currentView === calendarViews.YEAR }"
>
    <button
        type="button"
        class="agpr-datePicker-panel-prevButton"
        [agprTooltip]="prevButtonLabel"
        tooltipPosition="top"
        [useTooltipAsAriaLabel]="false"
        [attr.aria-label]="prevButtonAriaLabel"
        (click)="onPrevButtonClick()"
    >
        <span class="fa-solid fa-angle-left"></span>
    </button>

    <div class="agpr-datePicker-panel-title">
        @if (currentView === calendarViews.DATE) {
            <button
                type="button"
                [disabled]="disabled"
                [attr.aria-label]="monthButtonAriaLabel"
                (click)="switchToMonthView()"
            >
                {{ monthTitleValues[month.month] }}
            </button>
        }

        @if (currentView === calendarViews.YEAR) {
            <span>
                {{ yearPickerValues[0] }} - {{ yearPickerValues[yearPickerValues.length - 1] }}
            </span>
        } @else {
            <button
                type="button"
                [disabled]="disabled"
                [attr.aria-label]="yearButtonAriaLabel"
                (click)="switchToYearView()"
            >
                {{ currentView === calendarViews.MONTH ? currentYear : month.year }}
            </button>
        }
    </div>

    <button
        type="button"
        class="agpr-datePicker-panel-nextButton"
        [agprTooltip]="nextButtonLabel"
        tooltipPosition="top"
        [useTooltipAsAriaLabel]="false"
        [attr.aria-label]="nextButtonAriaLabel"
        (click)="onNextButtonClick()"
    >
        <span class="fa-solid fa-angle-right"></span>
    </button>
</div>

@if (currentView === calendarViews.DATE) {
    <div class="agpr-datePicker-date">
        <table
            class="agpr-datePicker-dateGrid"
            [ngClass]="{ 'agpr-datePicker-dateGrid--range': selectionMode === 'range' }"
        >
            <thead>
                <tr>
                    @for (weekDay of weekDays; track weekDay) {
                        <th scope="col">
                            <span class="agpr-datePicker-dateHeader">{{ weekDay }}</span>
                        </th>
                    }
                </tr>
            </thead>

            <tbody>
                @for (week of month.dates; track week) {
                    <tr>
                        @for (date of week; track date) {
                            <td
                                class="agpr-datePicker-dateCell"
                                [ngClass]="{
                                    'agpr-datePicker-dateCell--selected': date.selected,
                                    'agpr-datePicker-dateCell--selectedRangeStart': date.selectedRangeStart,
                                    'agpr-datePicker-dateCell--selectedRangeStartSingle': date.selectedRangeStart && !value?.[1],
                                    'agpr-datePicker-dateCell--selectedRangeEnd': date.selectedRangeEnd,
                                    'agpr-datePicker-dateCell--selectedInRange': date.selectedInRange,
                                    'agpr-datePicker-dateCell--disabled': !date.selectable,
                                    'agpr-datePicker-dateCell--otherMonth': date.otherMonth,
                                    'agpr-datePicker-dateCell--today': date.today
                                }"
                                [attr.aria-selected]="date.selected"
                                [attr.aria-label]="date.ariaLabel"
                                [attr.aria-disabled]="!date.selectable || null"
                                (keydown)="onDateCellKeydown($event, date)"
                                (click)="onDateSelect($event, date)"
                            >
                                <span class="agpr-datePicker-dateCellOuter">
                                    <span class="agpr-datePicker-dateCellInner">
                                        @if (dateTemplate) {
                                            <ng-container *ngTemplateOutlet="dateTemplate; context: { $implicit: date }"></ng-container>
                                        } @else {
                                            {{ date.day }}
                                        }
                                    </span>
                                </span>
                            </td>
                        }
                    </tr>
                }
            </tbody>
        </table>
    </div>
} @else if (currentView === calendarViews.MONTH) {
    <ul class="agpr-datePicker-month">
        @for (m of monthPickerValues; track m; let i = $index) {
            <li
                class="agpr-datePicker-monthCell"
                [attr.aria-label]="monthTitleValues[i]"
                (keydown)="onListCellKeydown($event, i)"
                (click)="onMonthSelect($event, i)"
            >
                {{ m }}
            </li>
        }
    </ul>
} @else if (currentView === calendarViews.YEAR) {
    <ul class="agpr-datePicker-year">
        @for (y of yearPickerValues; track y) {
            <li
                class="agpr-datePicker-yearCell"
                (keydown)="onListCellKeydown($event, y)"
                (click)="onYearSelect($event, y)"
            >
                {{ y }}
            </li>
        }
    </ul>
}
